<template>
  <div class="setting-main-container">
    <div class="card setting-card">
      <div class="page-header d-flex justify-content-between">
        <div>
          <h3 class="page-title">
            {{ $t('profile.documents.documents') }}
          </h3>
        </div>
        <base-button
          outline
          class="add-new-tax"
          color="theme"
          @click="addDocumentModel"
        >
          {{ $t('profile.documents.add_new') }}
        </base-button>
      </div>

        <table-component
        ref="documentData"
        :show-filter="false"
        :data="processDocuments"
        table-class="table tax-table"
        class="mb-3"
      >
        <table-column
          :label="$t('profile.documents.document_type')"
          show="documentType.name"
        />
        <table-column
          :label="$t('profile.documents.document_name')"
          show="name"
        />
        <table-column
          :sortable="false"
          :filterable="false"
          cell-class="action-dropdown"
        >
          <template slot-scope="row">
            <span> {{ $t('customers.action') }} </span>
            <v-dropdown>
              <a slot="activator" href="#"><dot-icon /></a>
              <v-dropdown-item>
                <div class="dropdown-item">
                  <a  :href="row.path"  target="_blank" v-if="row.path">
                    <font-awesome-icon icon="eye" class="dropdown-item-icon" />
                    {{ $t('general.view') }}
                  </a>
                </div>
              </v-dropdown-item>
            </v-dropdown>
          </template>
        </table-column>
      </table-component>

    </div>
  </div>
</template>
<script>

import { validationMixin } from 'vuelidate'
import { mapActions,mapGetters } from 'vuex'
const { required, email, maxLength, numeric } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data () {
    return {
      selectedCompany:null,
      userType:null,
    }
  },
  computed: {
    ...mapGetters('documentType', [
      'processDocuments'
    ]),
    ...mapGetters('business', [
      'business' ,
      'getBusinessPermission',
    ]),

  },
  watch: {
  },
  validations: {
     formData: {}
  },
  created() {
    this.checkBusinessPermission();
    this.getProcessDocuments();
  },
   destroyed(){
      this.falseBusinessPermission()
  },
  mounted(){},
  methods: {
    ...mapActions('modal', [
      'openModal'
    ]),
    ...mapActions('documentType', [
      'fetchProcessDocumentsByUser'
    ]),
    getProcessDocuments(){
      let data ={
        user_id :this.$route.params.id
      }
      let res =  this.fetchProcessDocumentsByUser(data)
    },
    ...mapActions('business', [
      'BusinessPermission',
      'falseBusinessPermission'
    ]),
    checkBusinessPermission(){
        this.BusinessPermission(this.$route.params.id)
    },
    addDocumentModel(){
       this.openModal({
        'title': 'Add Document',
        'componentName': 'ProcessDocumentModal',
      })
      this.$refs.documentData.refresh()
    },
  }
}
</script>
